import {lazy, Suspense} from 'react';
import {Outlet} from 'react-router-dom';
import {Layout as AppLayout} from 'src/layouts/app';

const IndexPage = lazy(() => import('src/pages/monitor/index'));


export const MonitorRoutes = [
    {
        path: 'monitor',
        element: (
            <AppLayout>
                <Suspense>
                    <Outlet/>
                </Suspense>
            </AppLayout>
        ),
        children: [
            {
                index: true,
                element: <IndexPage/>
            },
        ]
    }
];
